import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {EngineCampaignService, SelectItem} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-select-campaign',
    templateUrl: './select-campaign.component.html',
    styleUrls: ['./select-campaign.component.scss'],
    standalone: false
})
export class SelectCampaignComponent implements OnChanges {
    @Input() groupe: string;
    @Input() partner: string;
    @Input() value: number;
    @Output() valueChange = new EventEmitter<number>();
    example: string;
    items: SelectItem[] = [];
    item: number = null;

    constructor(private engineCampaignService: EngineCampaignService) {
    }

    ngOnChanges(changes: import('@angular/core').SimpleChanges): void {
        if (changes.groupe || changes.partner) {
            this.loadList();
        }
    }

    private loadList() {
        if (this.groupe && this.items.length === 0) {
            this.items = [];
            this.engineCampaignService.findAll(this.groupe).subscribe(res => {
                res.forEach(c => {
                    const item = {
                        label: `(${c.code}) ${c.name}`,
                        value: c.id
                    };
                    this.items.push(item);
                });
                this.item = this.value;
                this.valueChange.emit(this.value);
            });
        }
    }

    update($event: any) {
        this.valueChange.emit($event.value);
    }
}
